import { useEffect, useState } from "react";
import { ExternalLink, Newspaper } from "lucide-react";
import api from "../lib/api";
import { Spinner } from "./common";

export default function NewsFeed({ path, compact = false }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    setItems(null);
    api.get(path).then((r) => { if (alive) setItems(r.data.items || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [path]);

  if (!items) return <Spinner />;
  if (items.length === 0) return <p className="text-sm text-muted-foreground">No recent news found.</p>;

  return (
    <div className={compact ? "space-y-2" : "grid md:grid-cols-2 gap-3"} data-testid="news-feed">
      {items.map((n) => (
        <a key={n.id} href={n.link} target="_blank" rel="noreferrer" data-testid={`news-${n.id}`}
          onClick={() => api.post("/news/click", { link: n.link }).catch(() => {})}
          className="group block border border-zinc-300 bg-white p-4 hover:-translate-y-px hover:border-primary transition-[transform,border-color]">
          <div className="flex items-center gap-2 text-xs font-mono uppercase tracking-wide text-primary mb-1">
            <Newspaper className="w-3 h-3" />{n.source}
            {n.published ? <span className="text-muted-foreground normal-case tracking-normal">· {new Date(n.published).toLocaleDateString()}</span> : null}
          </div>
          <div className="font-heading font-700 text-base leading-snug group-hover:text-primary transition-colors">{n.title}</div>
          {n.snippet && <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{n.snippet}</p>}
          <div className="mt-2 inline-flex items-center gap-1 text-xs text-primary">Read at {n.source} <ExternalLink className="w-3 h-3" /></div>
        </a>
      ))}
    </div>
  );
}
